export default __webpack_public_path__ + "static/media/sneak-3.20c69cec.png";